import {Box, CircularProgress, Grid} from "@mui/material";

const Splashscreen = () => {
    return (
        <Box sx={{ display: "flex", flex: 1, p: 2, justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
            <Grid container spacing={2} justifyContent="center" alignItems="center" direction="column">
                <img src="/images/logo.png" style={{ width: '50%', height: 'auto' }} alt="Logo" />
                <CircularProgress />
            </Grid>
        </Box>
    );
}
export default Splashscreen;
